var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('div',{staticClass:"plane-loading-wrapper"},[_c('div',{staticClass:"icon-wrapper"},[_c('SvgIcon',{attrs:{"name":"plane-loading"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }